var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTotem = function SvgTotem(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.7976V1H15.5644",
    stroke: "#1E1E1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8405 8.20244L15.638 1",
    stroke: "#1E1E1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27607 8.20244L1.07362 1",
    stroke: "#1E1E1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27607 31L1.07362 23.7975",
    stroke: "#1E1E1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8282 8.20245H8.27606V31H22.8282V8.20245Z",
    fill: "white",
    stroke: "#1E1E1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6626 17.5398L13.8098 27.2945C13.8098 27.2945 13.7607 27.2944 13.7607 27.2576L14.8896 20.0797C14.8896 20.0797 14.8896 20.0307 14.865 20.0307H11.4663C11.4663 20.0307 11.4295 19.9939 11.4417 19.9693L14.8037 11.9325C14.8037 11.9325 14.816 11.908 14.8282 11.908H18.4969C18.4969 11.908 18.5337 11.9448 18.5215 11.9693L16.0061 17.4049C16.0061 17.4049 16.0061 17.4662 16.0307 17.4662H19.638C19.638 17.4662 19.6748 17.503 19.6626 17.5398V17.5398Z",
    fill: "white",
    stroke: "#1E1E1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTotem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/totem.69c1186f.svg";
export { ForwardRef as ReactComponent };